module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"delete":"Delete"},"zh-tw":{"delete":"刪除"}}')
  delete Component.options._Ctor
}
